export interface OnboardingTemplateTypes {
  templateName?: string;

  header: {
    header?: string;
    subHeader?: string;
  };

  specs: Array<{
    icon?: string;
    label?: string;
  }>;

  advertisementImage?: string;

  showLoginButton?: boolean;
  showDownArrow?: boolean;
}

export interface TemplateSpec {
  icon: string;
  label: string;
}

export interface TemplateData {
  id: string;
  welcome: {
    buttonName: string | null;
    loginLink: string | null;
    subTitle: string | null;
    title: string | null;
  };
  location: string | null;
  travelWith: string | null;
  lookingFor: string | null;
  budget: string | null;
  signUp: {
    specs: {
      icon: string;
      label: string;
    }[];
    title: string;
    subTitle: string;
    paramValue: string;
    booking: string;
    showDownArrow: boolean;
    showLoginButton: boolean;
  } | null;
  type: string;
  status: string;
  paramValue: string;
  createdAt: string;
  updatedAt: string;
}

export interface TemplateResponse {
  statusCode: number;
  message: string;
  data: TemplateData;
}
// export type OnboardingStep = "welcome" | "home" | "travelWith" | "lookingFor" | "budget" | "singUp";

// export const ONBOARDING_STEPS: OnboardingStep[] = ["welcome", "home", "travelWith", "lookingFor", "budget", "singUp"];
export type OnboardingStep = "lookingFor" | "travelWith" | "budget" | "home" | "singUp";

export const ONBOARDING_STEPS: OnboardingStep[] = ["lookingFor", "travelWith", "budget", "home", "singUp"];